<template>
    <v-chart class="chart" :option="option" :autoresize=true />
</template>

<script>
import * as echarts from 'echarts';
import VChart, { THEME_KEY } from "vue-echarts";
import { ref, defineComponent } from "vue";

export default defineComponent({
    name: "echart",
    components: {
        VChart
    },
    provide: {
        [THEME_KEY]: "dark"
    },
    setup () {
        var app = {};

        const posList = [
            'left',
            'right',
            'top',
            'bottom',
            'inside',
            'insideTop',
            'insideLeft',
            'insideRight',
            'insideBottom',
            'insideTopLeft',
            'insideTopRight',
            'insideBottomLeft',
            'insideBottomRight'
        ];
        app.configParameters = {
            rotate: {
                min: -90,
                max: 90
            },
            align: {
                options: {
                    left: 'left',
                    center: 'center',
                    right: 'right'
                }
            },
            verticalAlign: {
                options: {
                    top: 'top',
                    middle: 'middle',
                    bottom: 'bottom'
                }
            },
            position: {
                options: posList.reduce(function (map, pos) {
                    map[pos] = pos;
                    return map;
                }, {})
            },
            distance: {
                min: 0,
                max: 100
            }
        };
        app.config = {
            rotate: 90,
            align: 'left',
            verticalAlign: 'middle',
            position: 'insideBottom',
            distance: 15,
            onChange: function () {
                const labelOption = {
                    rotate: app.config.rotate,
                    align: app.config.align,
                    verticalAlign: app.config.verticalAlign,
                    position: app.config.position,
                    distance: app.config.distance
                };
                myChart.setOption({
                    series: [
                        {
                            label: labelOption
                        },
                        {
                            label: labelOption
                        }
                    ]
                });
            }
        };
        const labelOption = {
            show: true,
            position: app.config.position,
            distance: app.config.distance,
            align: app.config.align,
            verticalAlign: app.config.verticalAlign,
            rotate: app.config.rotate,
            formatter: '{c}  {name|{a}}',
            fontSize: 16,
            rich: {
                name: {}
            }
        };
        const option = ref({
            color: ['#f5365c', '#5e72e4', '#fb6340', '#ffd600', '#7ec365', '#2dce89', '#11cdef', '#5603ad', '#f3a4b5', '#8898aa', '#000'],
            title: {
                text: "",
                left: "center"
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                orient: "vertical",
                right: "0",
                top: "0",
                data: []
            },
            toolbox: {
                showTitle: false,
                show: true,
                orient: 'vertical',
                left: 'right',
                top: 'center',
                feature: {
                    mark: { show: true },
                    dataView: {title: "Zur Datenansicht", show: true, readOnly: false, lang: ['Datenansicht', 'Schliessen', 'Aktualisieren'] },
                    magicType: {title: {bar:"Zu Balken wechseln", line:"Zu Linien wechseln"}, show: true, type: ['line', 'bar'] },
                    saveAsImage: {title: "Als Bild speichern", show: true }
                },
                tooltip: { // same as option.tooltip
                    show: true,
                    formatter: function (param) {
                        return '<div>' + param.title + '</div>'; // user-defined DOM structure
                    },
                    backgroundColor: '#f7f8fd',
                    textStyle: {
                        fontSize: 12,
                    },
                    extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);' // user-defined CSS styles
                }
            },
            xAxis: [
                {
                    type: 'category',
                    axisTick: { show: false },
                    data: []
                }
            ],
            yAxis: [
                {
                    minInterval: 1,
                    type: 'value'
                }
            ],
            series: []
        });

        return { option };
    }
});
</script>

<style scoped>
.chart {
    min-height: 420px;
}
</style>
